import { configure, action, observable, runInAction } from 'mobx';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import { BotStore } from './BotStore';
import { StrategyStore } from './StrategyStore';
import { BillingStore } from './BillingStore';
import { StratCenter } from './StratCenter';
import { UserStore } from './UserStore';
import { OdysseyBotStore } from './OdysseyBot';
import { MakoBotStore } from './MakoBot';
import { BotConfigStore } from './BotConfigStore';
import { CopyTradingStore } from './CopyTradingStore';

configure({
    enforceActions: true
});

const mode = window.location.hostname.replace('www', '');
const CONFIG = {
    localhost: {
        hostUrl: 'http://localhost:3000',
        authApi: 'http://localhost:3001/auth/',
        signalsApi: 'http://localhost:3001/signals/',
        stratCenterApi: 'http://localhost:3001/strat_centre/',
        botApi: 'http://localhost:3001/bot/',
        leaderboardApi: 'http://localhost:3001/leaderboard/',
        billingApi: 'http://localhost:3001/billing/',
        functionsPath: 'https://us-central1-apex-trader-dev-20cb2.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyC6RyPyMnOTCjy9VMGyYKFCghpgB6TZiJE',
            authDomain: 'apex-trader-dev-20cb2.firebaseapp.com',
            databaseURL: 'https://apex-trader-dev-20cb2.firebaseio.com',
            projectId: 'apex-trader-dev-20cb2',
            storageBucket: 'apex-trader-dev-20cb2.appspot.com',
            messagingSenderId: '745246995557'
        }
    },
    'apex.local': {
        hostUrl: 'http://apex.local:3000',
        authApi: 'https://api.apextrader.io/dev/auth/',
        signalsApi: 'https://api.apextrader.io/dev/signals/',
        stratCenterApi: 'http://api.apextrader.io/v1/strat_centre/',
        botApi: 'https://api.apextrader.io/v1/bot/',
        billingApi: 'https://api.apextrader.io/v1/billing/',
        strategiesApi: 'https://api.apextrader.io/v1/strategies/',
        functionsPath: 'https://us-central1-apex-trader-dev-20cb2.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyC6RyPyMnOTCjy9VMGyYKFCghpgB6TZiJE',
            authDomain: 'apex-trader-dev-20cb2.firebaseapp.com',
            databaseURL: 'https://apex-trader-dev-20cb2.firebaseio.com',
            projectId: 'apex-trader-dev-20cb2',
            storageBucket: 'apex-trader-dev-20cb2.appspot.com',
            messagingSenderId: '745246995557'
        }
    },
    'apex-live.local': {
        hostUrl: 'http://apex-live.local:3000',
        authApi: 'https://api.apextrader.io/v1/auth/',
        signalsApi: 'http://localhost:3001/signals/',
        stratCenterApi: 'http://localhost:3001/strat_centre/',
        botApi: 'http://localhost:3001/bot/',
        billingApi: 'http://localhost:3001/billing/',
        leaderboardApi: 'http://localhost:3001/leaderboard/',
        strategiesApi: 'http://localhost:3001/strategies/',

        functionsPath: 'https://us-central1-apex-trader-live.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyCzpqAZMfm7poUR3BgOwgjd8dyLd5_KS5E',
            authDomain: 'apex-trader-live.firebaseapp.com',
            databaseURL: 'https://apex-trader-live.firebaseio.com',
            projectId: 'apex-trader-live',
            storageBucket: 'apex-trader-live.appspot.com',
            messagingSenderId: '967268809695'
        }
    },
    'apex-trader-dev-20cb2.firebaseapp.com': {
        hostUrl: 'https://apex-trader-dev-20cb2.firebaseapp.com',
        authApi: 'https://api.apextrader.io/dev/auth/',
        signalsApi: 'https://api.apextrader.io/dev/signals/',
        stratCenterApi: 'https://api.apextrader.io/dev/strat_centre/',
        botApi: 'https://api.apextrader.io/v1/bot/',
        functionsPath: 'https://us-central1-apex-trader-live.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyC6RyPyMnOTCjy9VMGyYKFCghpgB6TZiJE',
            authDomain: 'apex-trader-dev-20cb2.firebaseapp.com',
            databaseURL: 'https://apex-trader-dev-20cb2.firebaseio.com',
            projectId: 'apex-trader-dev-20cb2',
            storageBucket: 'apex-trader-dev-20cb2.appspot.com',
            messagingSenderId: '745246995557'
        }
    },
    'apex-trader-staging.firebaseapp.com': {
        hostUrl: 'https://apex-trader-staging.firebaseapp.com',
        authApi: 'https://api.apextrader.io/v1/auth/',
        signalsApi: 'https://api.apextrader.io/v1/signals/',
        stratCenterApi: 'https://api.apextrader.io/v1/strat_centre/',
        botApi: 'https://api.apextrader.io/v1/bot/',
        billingApi: 'https://api.apextrader.io/v1/billing/',
        strategiesApi: 'https://api.apextrader.io/v1/strategies/',
        leaderboardApi: 'https://api.apextrader.io/v1/leaderboard/',
        functionsPath: 'https://us-central1-apex-trader-live.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyCzpqAZMfm7poUR3BgOwgjd8dyLd5_KS5E',
            authDomain: 'apex-trader-live.firebaseapp.com',
            databaseURL: 'https://apex-trader-live.firebaseio.com',
            projectId: 'apex-trader-live',
            storageBucket: 'apex-trader-live.appspot.com',
            messagingSenderId: '967268809695'
        }
    },
    'console.apextrader.io': {
        hostUrl: 'https://console.apextrader.io',
        authApi: 'https://api.apextrader.io/v1/auth/',
        signalsApi: 'https://api.apextrader.io/v1/signals/',
        stratCenterApi: 'https://api.apextrader.io/v1/strat_centre/',
        botApi: 'https://api.apextrader.io/v1/bot/',
        billingApi: 'https://api.apextrader.io/v1/billing/',
        strategiesApi: 'https://api.apextrader.io/v1/strategies/',
        leaderboardApi: 'https://api.apextrader.io/v1/leaderboard/',
        functionsPath: 'https://us-central1-apex-trader-live.cloudfunctions.net',
        fbConfig: {
            apiKey: 'AIzaSyCzpqAZMfm7poUR3BgOwgjd8dyLd5_KS5E',
            authDomain: 'apex-trader-live.firebaseapp.com',
            databaseURL: 'https://apex-trader-live.firebaseio.com',
            projectId: 'apex-trader-live',
            storageBucket: 'apex-trader-live.appspot.com',
            messagingSenderId: '967268809695'
        }
    }
};
const EXCHANGES = {
    binance: {
        name: 'Binance',
        enabled: true,
        supported_base: ['BTC', 'ETH', 'BNB', 'XRP', 'USDT', 'PAX', 'TUSD', 'USDC', 'USDS'],
        tether_coins: ['USDT', 'PAX', 'TUSD', 'USDC', 'USDS'],
        featured_markets: [
            { base: 'BTC', quote: 'USDT' },
            { base: 'XRP', quote: 'USDT' },
            { base: 'ETH', quote: 'USDT' },
            { base: 'LTC', quote: 'USDT' },
            { base: 'EOS', quote: 'USDT' },
            { base: 'BNB', quote: 'USDT' }
        ],
        modes: [
            { id: 'live', name: 'Live Mode' },
            { id: 'test', name: 'Test Mode' }
        ]
    },
    // 'binanceje': {
    //     name: 'Binance Jersey',
    //     supported_base: ['EUR','GBP'],
    //     symbol_seperator: '',
    //     featured_market: [
    //        {base: 'BTC', quote: 'EUR'}],
    //      modes: [{id: 'live', name: 'Live Mode'}, {id: 'test', name: 'Test Mode'}]
    // },
    kucoin: {
        name: 'Kucoin',
        enabled: true,
        supported_base: ['BTC', 'ETH', 'KCS', 'NEO', 'USDT', 'DAI', 'PAX', 'TUSD', 'USDC', 'NUSD'],
        tether_coins: ['USDT', 'DAI', 'PAX', 'TUSD', 'USDC', 'NUSD'],
        featured_markets: [
            { base: 'BTC', quote: 'USDT' },
            { base: 'XRP', quote: 'USDT' },
            { base: 'ETH', quote: 'USDT' },
            { base: 'LTC', quote: 'USDT' },
            { base: 'EOS', quote: 'USDT' },
            { base: 'KCS', quote: 'USDT' }
        ],
        modes: [
            { id: 'live', name: 'Live Mode' },
            { id: 'test', name: 'Test Mode' }
        ]
    },
    kraken: {
        name: 'Kraken',
        enabled: true,
        supported_base: ['BTC', 'ETH', 'USD', 'EUR', 'CAD'],
        tether_coins: ['USD', 'EUR', 'CAD'],
        featured_markets: [
            { base: 'BTC', quote: 'USD', baseId: 'XBT' },
            { base: 'XRP', quote: 'USD' },
            { base: 'ETH', quote: 'USD' },
            { base: 'LTC', quote: 'USD' },
            { base: 'EOS', quote: 'USD' }
        ],
        modes: [
            { id: 'live', name: 'Live Mode' },
            { id: 'test', name: 'Test Mode' }
        ]
    }
    // coinbasepro: {
    //     name: 'CoinbasePro',
    //     enabled: true,
    //     supported_base: ['BTC', 'ETH', 'USDC', 'EUR'],
    //     tether_coins: ['USDC', 'EUR'],
    //     featured_markets: [
    //         { base: 'BTC', quote: 'USDC' },
    //         { base: 'XRP', quote: 'USDC' },
    //         { base: 'ETH', quote: 'USDC' },
    //         { base: 'LTC', quote: 'USDC' },
    //         { base: 'EOS', quote: 'USDC' }
    //     ],
    //     modes: [
    //         { id: 'live', name: 'Live Mode' },
    //         { id: 'test', name: 'Test Mode' }
    //     ]
    // }
};

firebase.initializeApp(CONFIG[mode].fbConfig);
const firestore = firebase.firestore();
const fbAuth = firebase.auth();

class Store {
    @observable baseConfig = null;

    constructor() {
        this.env = CONFIG[mode];
        this.exchangeConfig = EXCHANGES;
        this.fbAuth = fbAuth;
        this.db = firestore;

        this.botConfigStore = new BotConfigStore({ rootStore: this });
        this.botStore = new BotStore({ rootStore: this }); //apex stores
        this.odysseyBotStore = new OdysseyBotStore({ rootStore: this });
        this.makoBotStore = new MakoBotStore({ rootStore: this });
        this.copyTradingStore = new CopyTradingStore({ rootStore: this });
        this.strategyStore = new StrategyStore({ rootStore: this });
        this.billingStore = new BillingStore({ rootStore: this });
        this.userStore = new UserStore({ rootStore: this });
        this.stratCenter = new StratCenter({ rootStore: this });
    }

    /**
     * get UI configuration
     * @returns {Promise<void>}
     */
    @action async getBaseConfig() {
        const baseConfig = await firestore
            .collection('config')
            .doc('base')
            .get()
            .catch(e => console.log(e));
        runInAction(() => {
            this.baseConfig = baseConfig.data();
        });
    }
}

export const RootStore = new Store();



// WEBPACK FOOTER //
// ./src/stores/RootStore.js